'use strict';

var FaresOptimizerConstants = {
  RECOMMENDATION_STATUS: 'Recommendation status',
  MAX_STAY: 'Max Stay',
  NONE: 'None',
  MAX_STAY_START: 'maxStayStart',
  MAX_STAY_END: 'maxStayEnd',
  STATUS: 'Status',
  ADVANCE_PURCHASE_GROUP: 'Advance Purchase Groups',
  ADVANCE_PURCHASE_START: 'advancePurchaseStart',
  ADVANCE_PURCHASE_END: 'advancePurchaseEnd',
  AUTO_APPROVAL_STOPPED: 'Auto-Approval Stopped',
  AUTO_APPROVAL_STOPPED_KEY: 'autoApprovalStoppedReasonsFilterKeys',
  MIN_STAY: 'Min Stay',
  MIN_STAY_START: 'minStayStart',
  MIN_STAY_END: 'minStayEnd',
  HOST_CARRIER: 'Host Carrier',
  MARKET: 'Market',
  CABIN: 'Cabin',
  ORIGIN: 'Origin',
  DESTINATION: 'Destination',
  MARKET_TIER: 'Market Tier',
  NOT_ASSIGNED: 'Not assigned',
  EN_DASH: String.fromCharCode(8211),
  POS: 'POS',
  TYPE_CHECKBOX: 'checkbox',
  TYPE_COMBOBOX: 'combobox',
  HOST_VIEW: 'hostView',
  COMPETITIVE_VIEW: 'competitiveView',
  BENCHMARK_VIEW: 'benchmarkView',
  APPROVE_ALL: 'Approve all',
  REJECT_ALL: 'Reject all',
  UNDO_ALL: 'Undo all',
  NEW: 'New',
  FAILED: 'Failed',
  PENDING: 'Pending',
  APPROVED: 'Approved',
  NO_RECOM: 'No Recom',
  UNDONE: 'Undone',
  REJECTED: 'Rejected',
  FILED: 'Filed',
  VALID: 'Valid',
  INVALID: 'Invalid',
  VALIDATED: 'Validated',
  UNDO_INITIATED: 'Undo Initiated',
  UNDO_FILED: 'Undo Filed',
  VALIDATED_WITH_ERRORS: 'Validated With Errors',
  INTERMEDIATE: 'intermediate',
  FINAL: 'final',
  EFFECTIVE_FARES_CHART_TITLE: 'EFFECTIVE',
  RECOMMENDATION_CHART_TITLE: 'RECOMMENDATION',
  CURRENT_FARE_CHART_TITLE: 'CURRENT',
  WEB_FARE_CHART_TITLE: 'WEB FARE',
  CURRENT: 'CURRENT',
  COMPETITOR: 'COMPETITOR',
  CHART_MAX_DAYS: 364,
  RECOMMENDATION_CACHE_KEY: 'foAnalysisRecommendationLadder',
  FARE_TYPES: {
    1: 'OW',
    2: 'RT',
    3: 'OWNC'
  },
  FARE_TYPE: 'Fare Type',
  FARE_SOURCE: {
    ATPCO: 'ATPCO',
    ATPCO_CONS: 'ATPCO-Cons',
    WEB_FARE: 'WEB'
  },
  WEB_FARE_LOWEST_BASE_KEY: 'baseFare',
  WEB_FARE_LOWEST_TOTAL_KEY: 'totalFare',
  WEB_FARE_TOGGLE_LABELS: {
    BASE: 'Lowest Base',
    TOTAL: 'Lowest Total'
  },
  RBD_METHOD: {
    ENTRY_LEVEL_RBD: 'ENTRY LEVEL RBD',
    RBD_TO_RBD: 'RBD TO RBD',
    ORDINAL: 'ORDINAL',
    FBC_MAPPING: 'FBC MAPPING',
    UPPER_BOUND: 'UPPER BOUND',
    VALUE_BASED: 'VALUE BASED'
  },
  CATEGORY: {
    STRUCTURAL: 'STRUCTURAL',
    TACTICAL: 'TACTICAL',
    ADAPTIVE: 'ADAPTIVE'
  },
  LADDER_TYPE: {
    OFFER_TRANSLATION: 'OFFER_TRANSLATION',
    ADAPTIVE: 'ADAPTIVE'
  },
  TAX_OVERRIDE_PRIORITY: {
    HIGH: 'HIGH',
    LOW: 'LOW'
  },
  LADDER_METHOD: {
    EXPONENTIAL: 'EXPONENTIAL',
    LINEAR: 'LINEAR',
    MIN: 'MIN',
    MID: 'MID',
    MAX: 'MAX',
    NONE: 'NONE'
  },
  MORE_CONTENT_INDICATOR: '...',
  SESSION_STORAGE_KEYS: {
    RECALCULATED: 'ss_recalculated_ladder'
  },
  ACTION_CODE: 'Action Code',
  ACTION_CODE_KEY: 'recommendationActionCodes'
};
module.exports = FaresOptimizerConstants;